import cn from 'classnames';
import map from 'lodash/map';
import parse from 'html-react-parser';
import gsap from 'gsap';
import SVG from 'react-inlinesvg';
import { useRef, useEffect, useId } from 'react'
import { useKeenSlider } from 'keen-slider/react';
import { useBreakpoint } from '../../hooks/useBreakpoint';
import { Card } from './components/Card/Card';
import { Footnote } from '../Footnote/Footnote';
import 'keen-slider/keen-slider.scss';
import styles from './RealizeCards.module.scss';
import ScrollTrigger from 'gsap/ScrollTrigger';

export const RealizeCards = ({ footnote, items, moreLink, onClick, isForDarkSection }) => {
    const id = useId();
    const breakpoint = useBreakpoint()
    const cardsRef = useRef([])
    const sliderParams = useRef({
        initial: 0,
        mode: 'snap',
    })
    const [sliderRef, slider] = useKeenSlider(sliderParams.current)

    useEffect(() => {
        const sliderContainer = slider.current.container;

        if(cardsRef.current && sliderContainer) {
            const cardsAnim = cardsRef.current.slice(0, 4);

            gsap.from(cardsAnim, {
                yPercent: 50,
                stagger: .25,
                duration: 1,
                ease: 'power1.out',
                clearProps: 'all',
                scrollTrigger: {
                    id: 'slider-'+id,
                    trigger: sliderContainer,
                    start: 'top bottom',
                    end: 'top bottom',
                    refreshPriority: 10,
                    once: true
                }
            })

            return () => {
                ScrollTrigger.getById('slider-'+id)?.kill();
                gsap.set(cardsAnim, { clearProps: 'all' });
            }
        }
    }, [breakpoint, slider, id])

    useEffect(() => {
    const sliderElem = slider.current;

    if(sliderElem) {
        sliderParams.current.slides = {
            perView: breakpoint === 'desktop' ? 3 : 1,
            spacing: breakpoint === 'desktop' ? 20 : 10,
        }

        sliderElem.update(sliderParams.current)

        return () => {
            sliderElem.destroy()
        }
    }
    }, [breakpoint, slider])

    return (
        <div className={ styles.container }>
            { footnote && (
                <Footnote className={ styles.footnote } text={ footnote } textNotAlign />
            ) }
            <div
                className={ cn('keen-slider', styles.slider) }
                ref={ sliderRef }
            >
                { map(items, (item, index) => (
                    <div
                        key={ index }
                        className={ cn('keen-slider__slide', styles.slide) }
                    >
                        <div ref={ (el) => cardsRef.current[index] = el }>
                            <Card
                                { ...item }
                                onClick={ onClick ? () => onClick(index) : null }
                                isForDarkSection={ isForDarkSection }
                            />
                        </div>
                    </div>
                )) }
            </div>
            { moreLink && (
                <a className={ styles.button } href={ moreLink.href } target={ moreLink.target }>
                    <span className={ styles.buttonText }>{ parse(moreLink.text) }</span>
                    <span className={ styles.buttonIcon }>
                        <SVG src={ `/img/icons/icon-link-${moreLink.icon}.svg` } />
                    </span>
                </a>
            ) }
        </div>
    )
}